/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_RefreshInputs */

const en_error_refresh = /** @type {(inputs: Error_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh page`)
};

const pl_error_refresh = /** @type {(inputs: Error_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odśwież stronę`)
};

/**
* | output |
* | --- |
* | "Refresh page" |
*
* @param {Error_RefreshInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_refresh = /** @type {((inputs?: Error_RefreshInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_RefreshInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_error_refresh(inputs)
	return en_error_refresh(inputs)
});